import * as React from 'react';

import { cn, Select } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import { $processingTypesList } from '../../_state/processingTypes.state';
import { ProcessingTypeRecord } from '../../types/processingType';

import { EntitySelectProps } from '~/shared/components/select-fields/types';

export type SelectableProcessingType = ProcessingTypeRecord;

export const SelectProcessingType = ({
  value,
  onChange,
  ...props
}: EntitySelectProps<SelectableProcessingType>) => {
  const { data: entities, isLoading } = useAtomValue($processingTypesList);

  const options = React.useMemo(
    () =>
      (entities ?? []).map((it) => ({
        key: it.id,
        label: it.name,
      })),
    [entities],
  );

  const handleChange = React.useCallback(
    (newValue: string | undefined) => {
      const entity = entities?.find((it) => it.id === newValue);
      onChange?.(newValue ?? undefined, entity as SelectableProcessingType);
    },
    [entities, onChange],
  );

  return (
    <Select
      {...props}
      value={value ?? undefined}
      onChange={handleChange}
      className={cn('@SelectProcessingType', props.className)}
      options={options}
      isLoading={isLoading}
    />
  );
};
